export default __webpack_public_path__ + "static/media/tooltip_green_icon.3fd63a1c.svg";